window.TermsService = class
{

	static cache= {};
	static loaded = [];

	static async load(db_key) {

        try {
			if(this.loaded.includes(db_key)) return;

			// Si no esta en cache, obtener todo el group_id y agregarlo al cache
			var response = await fetch(`/api/fetch/terms/${db_key}`);
			response = await response.json();

			Object.assign(this.cache, response);

			this.loaded.push(db_key);

        } catch(ex) {
            console.log(ex);
        }
	}

	static get(term_id) {

		const term = this.cache[term_id];

		if(!term) {
			console.error(`term_id (${term_id}) doesn't exists`);
			return {};
		}

		return term;
	}
};
